import {
  ScrollCardStyles,
  GetInTouchStyles,
  FastestGrowingStyles,
} from "../Styles";
import React from "react";
import Heading from "../Heading";
import { ProductStyles } from "../Products/Styles";
import GlobalSubHeading from "../GlobalSubHeading";
import { getMeaning } from "../../utils/localization";
import { Box, Grid, Typography, Paper } from "@mui/material";

const CARDDATA = [
  {
    title: getMeaning("HME.CEO1"),
    subTitle: getMeaning("HME.CEO2"),
    description: getMeaning("HME.CEO3"),
  },
  {
    title: getMeaning("HME.VPSLS1"),
    subTitle: getMeaning("HME.VPSLS2"),
    description: getMeaning("HME.VPSLS3"),
  },
  {
    title: getMeaning("HME.BSNSHEAD1"),
    subTitle: getMeaning("HME.BSNSHEAD2"),
    description: getMeaning("HME.BSNSHEAD3"),
  },
];
const GetInTouch = () => {
  return (
    <Box
      sx={[
        FastestGrowingStyles.root,
        {
          // maxHeight: 400,
          height: {
            xs: 600, // Smallest screens
            sm: 650, // Small tablets
            md: 500, // Medium devices
            lg: 450, // Larger screens
            xl: 500, // Extra large screens
          },
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      ]}
    >
      <Grid container spacing={4}>
        {/* Left Section: Vertically centered */}
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box align="center">
              <GlobalSubHeading subTitle={getMeaning("HME.IAGVRFY1")} />
            </Box>

            <Heading title={getMeaning("HME.IAGVRFY2")} />

            {/* <Typography sx={HomeBannerStyles.BannerDescriptionThree}>
              {getMeaning("HME.IAGVRFY1")}
            </Typography>

            <Typography sx={HomeBannerStyles.bannerTitle}>
              {getMeaning("HME.IAGVRFY2")}
            </Typography> */}

            <Box>
              <img
                alt=""
                src={require("../../assets/images/Home/PartnerIAG.png")}
                style={ProductStyles.IAGSpinner}
              />
            </Box>
          </Box>
        </Grid>

        {/* Right Section: Auto-scrolling content */}
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              height: 400,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box
              sx={{
                // gap: 2,
                display: "flex",
                flexDirection: "column",
                animation: "scrollUp 16s linear infinite",
              }}
            >
              {CARDDATA.map((card, index) => (
                <Paper
                  // elevation={3}
                  sx={{
                    ...GetInTouchStyles.formCard,
                    p: { xs: 2, sm: 3, md: 2 },
                  }}
                  style={{
                    boxShadow: 6,
                    borderRadius: 6,
                    backgroundColor: "#fff",
                    // border: "0.6px solid #353E43",
                    border: "2px solid #cfd8dc",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: ".95rem", sm: "1.15rem", md: "1.2rem" }, // Adjusted text size
                        fontWeight: 600,
                        fontFamily: '"Poppins", serif',
                        textAlign: "left",
                      }}
                    >
                      {card.title}
                    </Typography>

                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0,9rem" },
                        color: "text.secondary",
                        fontFamily: '"Poppins", serif',
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {card.subTitle}
                    </Typography>

                    <Box sx={ScrollCardStyles.underline} />

                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.7rem",
                          md: "0.8rem",
                        },
                        color: "text.secondary",
                        fontFamily: '"Poppins", serif',
                        textAlign: "justify",
                        fontWeight: 400,
                      }}
                    >
                      {card.description}
                    </Typography>
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Auto scroll animation keyframes */}
      <style>
        {`
          @keyframes scrollUp {
            0% {
              transform: translateY(100%);
            }
            100% {
              transform: translateY(-100%);
            }
          }
        `}
      </style>
    </Box>
  );
};
export default GetInTouch;
